export const SchedulerConstants = {
    SCHEDULER_STATUS: {
        EXECUTED: 'executed',
        CANCELED: 'canceled',
        JUST_EXECUTED: 'just-executed',
        SCHEDULED: 'scheduled',
    },
    BROADCAST_DOMAIN: '@broadcast.msging.net',
    CHECK_SCHEDULE_STATUS_INTERVAL: 1000 * 30, // thirty seconds
    SCHEDULER_REPORT_FILE_EXTENSION: '.csv',
    SCHEDULER_REPORT_FILE_NAME_PREFIX: 'Scheduler_Report_',
    SCHEDULER_REPORT_URI: '/lists/{listIdentity}/messages/{messageId}/reports/csv?language={language}',
    SCHEDULER_POSTMASTER: 'postmaster@broadcast.msging.net',
    PAGE_SIZE: 20,
};
